import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as RegisterActions from 'auth/store/actions/index';
import * as DataActions from 'store/actions/medprocure/index';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles/index';
import { Button, Card, CardContent, Typography, MenuItem } from '@material-ui/core';
import classNames from 'classnames';
import { TextFieldFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { FuseAnimate } from '@fuse';

const styles = theme => ({
    root: {
        background: "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
        backgroundSize: 'cover'
    },
    intro: {
        color: '#ffffff'
    },
    card: {
        width: '100%',
        maxWidth: 400
    }
});

class Register extends Component {

    state = {
        canSubmit: false
    };

    constructor(props) {
        super(props);

        this.props.getAuthRoles();
    }

    form = React.createRef();

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    onSubmit = (model) => {
        this.props.registerUser(model);
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.register.error && (this.props.register.error.firstName || this.props.register.error.password || this.props.register.error.email)) {
            this.form.updateInputsWithError({
                ...this.props.register.error
            });

            this.props.register.error = null;
            this.disableButton();
        }

        if (this.props.user.role !== 'guest') {
            const pathname = this.props.location.state && this.props.location.state.redirectUrl ? this.props.location.state.redirectUrl : '/';
            this.props.history.push({
                pathname
            });
        }
        return null;
    }

    render() {
        const { classes, authRoleList } = this.props;
        const { canSubmit } = this.state;

        return (
            <div className={classNames(classes.root, "flex flex-col flex-1 flex-no-shrink p-24 md:flex-row md:p-0")}>

                <div
                    className={classNames(classes.intro, "flex flex-col flex-no-grow items-center p-16 text-center md:p-128 md:items-start md:flex-no-shrink md:flex-1 md:text-left")}>

                    {/* <FuseAnimate animation="transition.expandIn">
                        <img className="w-256 mb-32" src="assets/images/logos/imb.svg" alt="logo" />
                    </FuseAnimate> */}

                    <FuseAnimate animation="transition.slideUpIn" delay={300}>
                        <Typography variant="h3" color="inherit" className="font-light">
                            Welcome to the University!
                        </Typography>
                    </FuseAnimate>

                    <FuseAnimate delay={400}>
                        <Typography variant="subtitle1" color="inherit" className="max-w-512 mt-16">
                            <Typography variant="subtitle1" color="inherit" className="max-w-512 mt-16">
                                “Focus on the journey not the destination. Joy is found not in finishing an activity but in doing it.”
                            </Typography>
                            <Typography variant="subtitle1" color="inherit" className="max-w-512 mt-16" style={{ paddingLeft: '50px' }}>
                                ― Greg Anderson
                            </Typography>
                        </Typography>
                    </FuseAnimate>
                </div>

                <FuseAnimate animation={{ translateX: [0, '100%'] }}>
                    <Card className={classNames(classes.card, "mx-auto m-16 md:m-0")}>

                        <CardContent className="flex flex-col items-center justify-center p-32 md:p-48 md:pt-128 ">

                            <Typography variant="h6" className="md:w-full mb-32">CREATE AN ACCOUNT</Typography>

                            <Formsy
                                onValidSubmit={this.onSubmit}
                                onValid={this.enableButton}
                                onInvalid={this.disableButton}
                                ref={(form) => this.form = form}
                                className="flex flex-col justify-center w-full"
                            >
                                <TextFieldFormsy
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    className="mb-16"
                                    type="text"
                                    name="firstName"
                                    label="First Name"
                                    required
                                />

                                <TextFieldFormsy
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    className="mb-16"
                                    type="text"
                                    name="lastName"
                                    label="Last Name"
                                    required
                                />

                                <TextFieldFormsy
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    className="mb-16"
                                    type="text"
                                    name="email"
                                    label="Email"
                                    validations="isEmail"
                                    validationErrors={{
                                        isEmail: 'Please enter a valid email'
                                    }}
                                    required
                                />

                                <TextFieldFormsy
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    className="mb-16"
                                    type="password"
                                    name="password"
                                    label="Password"
                                    validations="equalsField:password-confirm"
                                    validationErrors={{
                                        equalsField: 'Passwords do not match'
                                    }}
                                    required
                                />

                                <TextFieldFormsy
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    className="mb-16"
                                    type="password"
                                    name="password-confirm"
                                    label="Confirm Password"
                                    validations="equalsField:password"
                                    validationErrors={{
                                        equalsField: 'Passwords do not match'
                                    }}
                                    required
                                />

                                <SelectFormsy
                                    className="my-24"
                                    name="authRole"
                                    label="User Role"
                                    value="0"
                                    validations={{
                                        matchRegexp: /[1234]/
                                    }}
                                    validationError="Select User Role"
                                >
                                    {authRoleList.map((authRole) =>
                                        <MenuItem
                                            key={authRole.auth_role_id}
                                            value={authRole.auth_role_id}
                                        >
                                            {authRole.RoleName}
                                        </MenuItem>
                                    )}
                                </SelectFormsy>


                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className="w-full mx-auto mt-16 normal-case"
                                    aria-label="Create an Account"
                                    disabled={!canSubmit}
                                >
                                    Create an Account
                                </Button>
                            </Formsy>

                            <div className="flex flex-col items-center justify-center pt-32 pb-24">
                                <span className="font-medium">Already have an account?</span>
                                <Link className="font-medium" to="/login">Login</Link>
                            </div>

                            <div className="flex flex-col items-center">
                            </div>
                        </CardContent>
                    </Card>
                </FuseAnimate>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        registerUser: RegisterActions.registerUser,
        getAuthRoles: DataActions.getAuthRoles
    }, dispatch);
}

function mapStateToProps({ auth, medprocure }) {
    return {
        login: auth.login,
        user: auth.user,
        register: auth.register,
        authRoleList: medprocure.data.authRoleList
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Register)));


// WEBPACK FOOTER //
// src/main/content/auth/Register.js